import { VueExtension } from '../../utils/extensions/vue';
import Switch from './switch.jsx';
import './switch.scss';

VueExtension.WithInstall(Switch);

export default Switch;
